import api from '../../config/axios.js';

const state = {
    payment: {},
    errorPayment: "",
    successPayment: "",
    summary: {
        "month": "Carregando...",
        "year": "Carregando...",
        "payment_url": null,
        "date_payment": null,
        "status": "Carregando...",
        "value": "Carregando...",
        "total_chats": "Carregando..."
    },
    errorSummary: "",
    errorPaymentModeDefault: "",
    paymentModeDefault: [],
    loadingPaymentMode: true,
    errorPaymentHistory: "",
    invoiceHistory: [],
    invoiceHistoryPagination: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0,
    },
    currentPlan: null,
    availablePlans: [],
    loadingCurrentPlan: true,
    loadingAvailablePlans: true,
    loadingChangePlan: false,
    errorCurrentPlan: "",
    errorAvailablePlans: "",
    errorChangePlan: "",
    successChangePlan: "",
    daysExportFiles: 10,
    servicePrice: "1,98",
    gbFree: 5,
    planChangePaymentUrl: null,
}
const getters = {
    getPayment: state => state.payment,
    getErrorPayment: state => state.errorPayment,
    getSuccessPayment: state => state.successPayment,
    getSummary: state => state.summary,
    getErrorSummary: state => state.errorSummary,
    getErrorPaymentModeDefault: state => state.errorPaymentModeDefault,
    getPaymentModeDefault: state => state.paymentModeDefault,
    getLoadingPaymentMode: state => state.loadingPaymentMode,
    getErrorPaymentHistory: state => state.errorPaymentHistory,
    getInvoiceHistory: state => state.invoiceHistory,
    getInvoiceHistoryPagination: state => state.invoiceHistoryPagination,
    getCurrentPlan: state => state.currentPlan,
    getAvailablePlans: state => state.availablePlans,
    getLoadingCurrentPlan: state => state.loadingCurrentPlan,
    getLoadingAvailablePlans: state => state.loadingAvailablePlans,
    getLoadingChangePlan: state => state.loadingChangePlan,
    getErrorCurrentPlan: state => state.errorCurrentPlan,
    getErrorAvailablePlans: state => state.errorAvailablePlans,
    getErrorChangePlan: state => state.errorChangePlan,
    getSuccessChangePlan: state => state.successChangePlan,
    getDaysExportFiles: state => state.daysExportFiles,
    getServicePrice: state => state.servicePrice,
    getGbFree: state => state.gbFree,
    getPlanChangePaymentUrl: state => state.planChangePaymentUrl,
}
const actions = {

    // REALIZANDO A CRIAÇÃO DA ASSINATURA DE PAGAMENTO
    async setProcessSubscriptionPayment({ commit }, data) {
        await api.axios.post('/api/checkout/process', data).catch(error => {
            if(error && error.response && error.response.data && error.response.data){
                commit("setErrorPayment", error.response.data);
            }

        }).then(function(response){
            if(response && response.status == 200){
                commit('setSuccessPayment', "pagamento confirmado, o serviço já está disponibilizado !");
                location.reload();
            }
        });
    },
    // ZERANDO MENSAGEM DE ERRO NO PROCESSAMENTO DE PAGAMENTO
    setResetErrorPayment({ commit }){
        commit("setErrorPayment", "");
    },
    // BUSCANDO O DÉBITO DO CLIENTE
    async setSummary({ commit }) {
        await api.axios.get('/api/checkout/summary').catch(function(){
            
            commit("setErrorSummary", "Erro ao buscar informações de pagamento, por favor tente novamente mais tarde !");

        }).then(function(response){
            if(response && response.status == 200){
                commit('setSummary', response.data);
            }
        });
    },
    // BUSCANDO A QUANTIDADE DE DIAS QUE OS ARQUIVOS FICARAM NA NUVEM APÓS O CANCELAMENTO DO SERVIÇO
    async setDaysExportFiles({ commit }) {
        await api.axios.get('/api/export/files/finish').catch(function(){
            
            commit("setDaysExportFiles", 10);

        }).then(function(response){
            if(response && response.status == 200){
                commit('setDaysExportFiles', response.data);
            }
        });
    },
    // BUSCANDO O VALOR DO SERVIÇO
    async setServicePrice({ commit }) {
        await api.axios.get('/api/service/price').catch(function(){
            
            commit("setServicePrice", false);

        }).then(function(response){
            if(response && response.status == 200){
                commit('setServicePrice', response.data);
            }
        });
    },
    // BUSCANDO OS GIGAS LIVRES
    async setGbFree({ commit }) {
        await api.axios.get('/api/gb/free').catch(function(){
            
            commit("setGbFree", 5);

        }).then(function(response){
            if(response && response.status == 200){
                commit('setGbFree', response.data);
            }
        });
    },
    // BUSCANDO MODO DE PAGAMENTO PADRÃO DO CLIENTE
    async setPaymentModeDefault({ commit }, data) {
        await api.axios.post('/api/payment/mode', data).catch(function(){
            
            commit("setErrorPaymentModeDefault", "Erro ao buscar forma de pagamento padrão, por favor tente novamente mais tarde !");

        }).then(function(response){
            commit('setLoadingPaymentMode', false);
            if(response && response.status == 200){
                commit('setPaymentModeDefault', response.data);
            }
        });
    },
    // BUSCANDO HISTÓRICO DE PAGAMENTOS DO CLIENTE
    async setInvoiceHistory({ commit }, page = 1) {
        await api.axios.get(`/api/invoice/history?page=${page}`).catch(function(){
            
            commit("setErrorPaymentHistory", "Erro ao buscar histórico de pagamentos do cliente, por favor tente novamente mais tarde !");
            commit("setInvoiceHistory", []);
            commit("setInvoiceHistoryPagination", {
                current_page: 1,
                last_page: 1,
                per_page: 10,
                total: 0,
            });

        }).then(function(response){
            if(response && response.status == 200 && response.data){
                const payload = response.data;
                const list = Array.isArray(payload.data) ? payload.data : payload;
                const pagination = Array.isArray(payload.data)
                    ? {
                        current_page: payload.current_page || page,
                        last_page: payload.last_page || 1,
                        per_page: payload.per_page || list.length,
                        total: payload.total || list.length,
                    }
                    : {
                        current_page: 1,
                        last_page: 1,
                        per_page: list.length,
                        total: list.length,
                    };

                commit('setInvoiceHistory', list);
                commit('setInvoiceHistoryPagination', pagination);
            }
        });
    },
    // BUSCANDO O PLANO CONTRATADO PELO CLIENTE
    async setCurrentPlan({ commit }) {
        commit("setLoadingCurrentPlan", true);
        commit("setErrorCurrentPlan", "");

        await api.axios.get('/api/payment/current-plan').catch(function(){
            
            commit("setErrorCurrentPlan", "Erro ao buscar plano contratado, por favor tente novamente mais tarde !");
            commit("setCurrentPlan", null);

        }).then(function(response){
            commit("setLoadingCurrentPlan", false);
            if(response && response.status == 200){
                commit('setCurrentPlan', response.data);
            }
        });
    },
    // BUSCANDO OS PLANOS DISPONÍVEIS PARA TROCA
    async setAvailablePlans({ commit }) {
        commit("setLoadingAvailablePlans", true);
        commit("setErrorAvailablePlans", "");

        await api.axios.get('/api/payment/plans').catch(function(){
            
            commit("setErrorAvailablePlans", "Erro ao buscar planos disponíveis, por favor tente novamente mais tarde !");
            commit("setAvailablePlans", []);

        }).then(function(response){
            commit("setLoadingAvailablePlans", false);
            if(response && response.status == 200){
                commit('setAvailablePlans', response.data);
            }
        });
    },
    // SOLICITANDO TROCA DE PLANO
    async setChangePlan({ commit }, planId) {
        commit("setLoadingChangePlan", true);
        commit("setErrorChangePlan", "");
        commit("setSuccessChangePlan", "");
        commit("setPlanChangePaymentUrl", null);

        let changed = false;

        await api.axios.post('/api/payment/change-plan', { subscription_plan_id: planId }).catch(function(error){

            if(error && error.response && error.response.data && error.response.data.message){
                commit("setErrorChangePlan", error.response.data.message);
            } else {
                commit("setErrorChangePlan", "Erro ao trocar plano, por favor tente novamente mais tarde !");
            }

        }).then(function(response){
            if(response && (response.status == 200 || response.status == 201)){
                changed = true;
                const paymentUrl = response.data && response.data.payment_url ? response.data.payment_url : null;
                commit("setPlanChangePaymentUrl", paymentUrl);
                commit("setSuccessChangePlan", paymentUrl ? "Fatura de troca de plano criada. Abrimos o pagamento em uma nova aba." : "Solicitacao de troca de plano registrada.");
                if (paymentUrl) {
                    window.open(paymentUrl, "_blank", "noopener,noreferrer");
                }
            }
        });

        commit("setLoadingChangePlan", false);

        return changed;
    },
}
const mutations = {
    setProcessSubscriptionPayment: function(state, data){
        state.payment = data;
    },
    setErrorPayment: function(state, data){
        state.errorPayment = data;
    },
    setSuccessPayment: function(state, data){
        state.successPayment = data;
    },
    setErrorSummary: function(state, data){
        state.errorSummary = data;
    },
    setSummary: function(state, data){
        state.summary = data;
    },
    setErrorPaymentModeDefault: function(state, data){
        state.errorPaymentModeDefault = data;
    },
    setPaymentModeDefault: function(state, data){
        state.paymentModeDefault = data;
    },
    setLoadingPaymentMode: function(state, data){
        state.loadingPaymentMode = data;
    },
    setErrorPaymentHistory: function(state, data){
        state.errorPaymentHistory = data;
    },
    setInvoiceHistory: function(state, data){
        state.invoiceHistory = data;
    },
    setInvoiceHistoryPagination: function(state, data){
        state.invoiceHistoryPagination = data;
    },
    setCurrentPlan: function(state, data){
        state.currentPlan = data;
    },
    setAvailablePlans: function(state, data){
        state.availablePlans = data;
    },
    setLoadingCurrentPlan: function(state, data){
        state.loadingCurrentPlan = data;
    },
    setLoadingAvailablePlans: function(state, data){
        state.loadingAvailablePlans = data;
    },
    setLoadingChangePlan: function(state, data){
        state.loadingChangePlan = data;
    },
    setErrorCurrentPlan: function(state, data){
        state.errorCurrentPlan = data;
    },
    setErrorAvailablePlans: function(state, data){
        state.errorAvailablePlans = data;
    },
    setErrorChangePlan: function(state, data){
        state.errorChangePlan = data;
    },
    setSuccessChangePlan: function(state, data){
        state.successChangePlan = data;
    },
    setDaysExportFiles: function(state, data){
        state.daysExportFiles = data;
    },
    setServicePrice: function(state, data){
        state.servicePrice = data;
    },
    setGbFree: function(state, data){
        state.gbFree = data;
    },
    setPlanChangePaymentUrl: function(state, data){
        state.planChangePaymentUrl = data;
    },
}
export default {
    state,
    getters,
    actions,
    mutations
}
